import { Center } from '@tempmee/react';
import { useState } from 'react';
import { DotsMenu, MenuItem } from '../../../../commonComponents/DotsMenu';
import { useCancelJobMutation } from '~/domain/Jobs';
import { OutlineTrashIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import AnimatedCloseCircle from '../../../shared/AnimatedCloseCircle';
import ConfirmPopup from '../../../shared/ConfirmPopup';

export const CancelShift = ({ item }) => {
  const { mutate: cancelJob, isPending } = useCancelJobMutation();
  const [showPopup, setShowPopup] = useState(false);

  return (
    <td>
      <Center width="100%" height="100%">
        <DotsMenu position="bottom">
          <MenuItem
            Icon={() => <OutlineTrashIcon color={colors.neutral[600]} />}
            text={item?.dashboardJobApi?.isOnsiteInterview ? 'Cancel Interview' : 'Cancel Shift'}
            onClick={() => setShowPopup(true)}
          />
        </DotsMenu>
      </Center>

      {showPopup && (
        <ConfirmPopup
          Icon={() => <AnimatedCloseCircle />}
          title="Are you sure you want to cancel?"
          titleStyle={{ marginTop: 20 }}
          description={
            item?.dashboardJobApi?.isOnsiteInterview ? (
              <>
                Are you sure you would like to cancel the onsite interview
                <br />
                for <b>{item?.date}</b>
              </>
            ) : (
              <>
                Are you sure you would like to cancel the shift for
                <br />
                <b>{item?.date}</b>
              </>
            )
          }
          closePopup={(event) => {
            event.stopPropagation();
          }}
          descriptionStyle={{ marginBottom: 50, width: '100%' }}
          leftButtonText="Go Back"
          leftButtonAction={() => setShowPopup(false)}
          rightButtonText={
            item?.dashboardJobApi?.isOnsiteInterview ? 'Cancel Interview' : 'Cancel Shift'
          }
          leftButtonDisabled={isPending}
          rightButtonDisabled={isPending}
          rightButtonAction={() => {
            cancelJob({ jobId: item?.id }, { onSuccess: () => setShowPopup(false) });
          }}
          leftButtonStyle={item?.dashboardJobApi?.isOnsiteInterview ? { width: 180 } : {}}
          rightButtonStyle={item?.dashboardJobApi?.isOnsiteInterview ? { width: 180 } : {}}
        />
      )}
    </td>
  );
};
